"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponDiscountType = exports.CouponCodeType = void 0;
var CouponCodeType;
(function (CouponCodeType) {
    CouponCodeType[CouponCodeType["Kickstarter"] = 1] = "Kickstarter";
    CouponCodeType[CouponCodeType["IndieGoGo"] = 2] = "IndieGoGo";
    CouponCodeType[CouponCodeType["CreditOnly"] = 3] = "CreditOnly";
})(CouponCodeType = exports.CouponCodeType || (exports.CouponCodeType = {}));
/** Mapping with Chargebee - Coupon Ids */
var CouponDiscountType;
(function (CouponDiscountType) {
    CouponDiscountType["Kickstarter33"] = "BACKER_KICKSTARTER";
    CouponDiscountType["IndieGoGo16"] = "BACKER_INDIEGOGO";
})(CouponDiscountType = exports.CouponDiscountType || (exports.CouponDiscountType = {}));
//# sourceMappingURL=backerCode.js.map